import React from "react"
import * as styles from "./map2.module.scss"
import { fromPairs } from 'lodash'
import classNames from 'classnames';
import MapHeadline from "./map-headline";
import MapTextbox from "./map-textbox";
import Stat from "./stat";
import {Grid, GridItem} from './grid';
import { useImage } from '../hooks/useImage';
import { useMediaQuery } from 'react-responsive'

export function Stats(props) {
    const kpis = props.kpis
    if (kpis.length === 0) {
        return null
    }
    return (
        <>
                <Grid cols-xs={1} cols-md={2} cols-lg={2}>
                    {kpis.map(kpi => {
                        return (
                            <GridItem>
                                <Stat
                                    value={kpi.label}
                                    label={kpi.remark}
                                    image={kpi.icon}
                                />
                            </GridItem>
                        )
                    })}                                               
                </Grid>     
        </>
    )
}

export function Textboxes(props) {
    const texts = props.texts
    if (texts.length === 0) {
        return null
    }
    return (
        <>
            {texts.map(text => {
                return (
                    <MapTextbox
                        title={text.headline}
                        text={text.text}
                        image={text.image}
                    />
                )
            })}                                               
        </>
    )

}

export const Section = (props) => <div className={classNames({[styles.section]: true, [styles.sectionResponsive]: props.responsive})}>{props.children}</div>

export const Column = (props) => <div className={styles.column}>{props.children}</div>


export default function Map(props) {
    const bgImage = useImage(props.image).publicURL
    console.log(props)
    const isXs = true
    const isLg = useMediaQuery({
        query: '(min-width: 991px)'
    })
    const isMd = useMediaQuery({
        query: '(min-width: 767px)'
    })
    let margins = {
        top: 0,
        bottom: 0,
        bottomLeftExtra: 0,
        bottomRightExtra: 0
    };
    if (isMd) { 
        margins = props.margins.md
    } else if (isLg) {
        margins = props.margins.lg
    }
    return (
        <div className={styles.map}>
            <div class={styles.desktop}>
                <Section>
                    <div className={styles.column}>
                    <MapHeadline
                        image="icon-big-signal.svg"
                        headline="Mobilfunk"
                    />
                    <Stats kpis={props.mobilfunk.kpis} />
                    <Textboxes texts={props.mobilfunk.texts.slice(0,2)} />
                    </div>
                    <div className={styles.column}>
                    <MapHeadline
                        image="icon-big-supply.svg"
                        headline="Festnetz"
                    />
                    <Stats kpis={props.festnetz.kpis} />
                    <Textboxes texts={props.festnetz.texts.slice(0,2)} />

                    </div>                                           
                </Section> 
                <img className={styles.image} style={{marginTop: margins.top * -1}} src={bgImage} />
                <div className={styles.section} style={{marginTop: margins.bottom * -1}}>
                    <div className={styles.column}  style={{marginTop: margins.bottomLeftExtra * -1}}>
                    <Textboxes texts={props.mobilfunk.texts.slice(2)} />

                    </div>
                    <div className={styles.column} style={{marginTop: margins.bottomRightExtra * -1}}>
                    <Textboxes texts={props.festnetz.texts.slice(2)} />
                    <MapHeadline
                        image="icon-big-iot.svg"
                        headline="Internet of Things"
                    />         
                    <Stats kpis={props.iot.kpis} />
                    <Textboxes texts={props.iot.texts} />
                    </div>                                           
                </div>
            </div>
            <div class={styles.mobile}>
            <MapHeadline
                        image="icon-big-signal.svg"
                        headline="Mobilfunk"
                    />
                    <Stats kpis={props.mobilfunk.kpis} />
                    <Textboxes texts={props.mobilfunk.texts.slice(0,2)} />
                    <img className={styles.image}   src={bgImage} />
                    <Textboxes texts={props.mobilfunk.texts.slice(2)} />
                    <MapHeadline
                        image="icon-big-supply.svg"
                        headline="Festnetz"
                    />
                    <Stats kpis={props.festnetz.kpis} />
                    <Textboxes texts={props.festnetz.texts} />
                    <MapHeadline
                        image="icon-big-iot.svg"
                        headline="Internet of Things"
                    />         
                    <Stats kpis={props.iot.kpis} />
                    <Textboxes texts={props.iot.texts} />   

            </div>             
        </div>
    )
}